export const CLIENT_NAME = "ewp";
export const CLIENT_DISPLAY_NAME = "EWP";
export const MODAL_CONFIRM_BUTTON_LABEL = "übernehmen";
export const BASE_ASSET_URL = ` https://esr.fe-bis.de/de/${CLIENT_NAME}/`;
//export const BASE_ASSET_URL = "http://localhost:5173/";
export const PLZ_VALIDATION = (plz : string) => plz.length == 5;